import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import { TableCell } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { withStyles } from 'material-ui/styles';
import { fieldInputPropTypes } from 'redux-form';

import { ALLOW_PREPREG_CONFIGURATION } from '../../../constants/features';
import {
  prepregToString,
  prepregConstructionToStr
} from '../../../lib/material';
import { materialPropType } from '../../../lib/shapes';
import Prepreg from '../../../models/Prepreg';
import MaterialsTable from '../MaterialsTable';

const styles = () => ({
  container: {
    display: 'flex',
  },
  textField: {
    width: '3em',
    float: 'right',
    clear: 'both',
  },
  postFix: {
    margin: '5px 0 0 0'
  }
})

export class PrepregPicker extends Component {
  constructor(props) {
    super(props);
    const { target } = this.props;
    const selectedMaterials=
      target.material.reduce((acc, cur) => {
        const id = cur.material.id
        acc[id] = cur;
        return acc;
      }, {});
    this.state = { selectedMaterials };
    this.handleChange = this.handleChange.bind(this);
    this.handleCountChange = this.handleCountChange.bind(this);
  }

  handleChange(id) {
    const { input, options } = this.props;
    let { selectedMaterials } = this.state;
    const { onChange } = input;
    const selected = options
      .find(option => option.material.id.toString() === id);
    let updated;

    if (selected === undefined) {
      return;
    }
    // clear selectedMaterials if new material has different resin id.
    const resinIds = Object.keys(selectedMaterials).map(key => selectedMaterials[key].material.resinId);
    const selectedResinId = selected.material.resinId;
    if (resinIds.length > 0 && resinIds[0] !== selectedResinId) {
      selectedMaterials = {};
    }
    
    if (selectedMaterials[id] === undefined) {
      updated = { ...selectedMaterials, [id]: selected }
    } else {
      updated = Object.assign({}, selectedMaterials);
      delete updated[id];
    }

    this.setState({ selectedMaterials: updated },() => {
      const { selectedMaterials } = this.state;
      onChange(selectedMaterials);
    })
  }

  handleCountChange(id, count) {
    const { input } = this.props;
    const { selectedMaterials } = this.state;
    const { onChange } = input;

    if (selectedMaterials[id] !== undefined) {
      const updated = { ...selectedMaterials[id], count };
      const newState = { ...selectedMaterials, [id]: updated };
      this.setState({ selectedMaterials: newState },
        () => onChange(newState))
    }
  }

  render() {
    const { classes, options, lengthUnit } = this.props;
    const { selectedMaterials } = this.state;
    const materials = options.map(o => {
      const id = o.material.id;
      return selectedMaterials[id] ? selectedMaterials[id] : o;
    });
    const selectedStr = Object.keys(selectedMaterials).length > 0
      ? prepregToString(
        Object.keys(selectedMaterials).map(key => selectedMaterials[key]),
        lengthUnit
      )
      : "None Selected";
    const tableOptions = materials.map(m => m.material);
    const shiftHeadCols = ALLOW_PREPREG_CONFIGURATION ? 2 : 1;
    const columns = [
      'construction',
      'resinContent',
      'thickness',
      'dkdf'
    ];

    return (
      <MaterialsTable
        materials={tableOptions}
        header={selectedStr}
        shiftHeadCols={shiftHeadCols}
        columns={columns}
        lengthUnit={lengthUnit}
        selectRender={material => {
          const { id } = material;
          const thisMaterial = materials.find(m => m.material.id === id);
          const count = thisMaterial ? thisMaterial.count : 1;
          const selected = selectedMaterials[material.id] !== undefined
          const construction = prepregConstructionToStr([{ count: 1, material }]);
          const onCountChange =
            event => this.handleCountChange(
              id.toString(),
              Number(event.target.value)
            );

          return [ 
            <TableCell key="checkbox" component="th" scope="row">
              <Checkbox
                checked={selected}
                onChange={() => this.handleChange(id)}
                value={id.toString()}
                name="material"
                aria-label={construction}
              />
            </TableCell>,
            ALLOW_PREPREG_CONFIGURATION ? (
              <TableCell key="input" component="th" scope="row">
                <div className={classes.container}>
                  <TextField
                    value={count}
                    disabled={!selected}
                    onChange={onCountChange}
                    type="number"
                    className={classes.textField}
                    inputProps={{
                      min: 1,
                      max: 99
                    }}
                  />
                  <div className={classes.postFix}>x</div>
                </div>
              </TableCell>
            ) : null
          ];
        }}
      />
    );
  }
}

PrepregPicker.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
    textField: PropTypes.string,
    postFix: PropTypes.string
  }).isRequired,
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(materialPropType)).isRequired,
  target: PropTypes.instanceOf(Prepreg).isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default withStyles(styles)(PrepregPicker);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/PrepregPicker.js